import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Plus } from "@air/next-icons";
import classNames from "classnames";
import { memo } from "react";
import { SELECT_CREATE_OPTION } from "~/components/Select/shared/testIDs";
export const SelectCreateOption = /*#__PURE__*/ memo((param)=>{
    let { onClick, hideSpacer, value, createVerb = "Create" } = param;
    return /*#__PURE__*/ _jsx("li", {
        className: classNames("w-full", hideSpacer ? "border-t-none mt-0" : "mt-2 border-t border-t-grey-5"),
        "data-testid": SELECT_CREATE_OPTION,
        onClick: onClick,
        children: /*#__PURE__*/ _jsx("div", {
            className: classNames("w-full", hideSpacer ? "mt-0" : "mt-2"),
            children: /*#__PURE__*/ _jsxs("div", {
                className: classNames("flex w-full cursor-pointer items-center justify-start", hideSpacer ? "mt-0" : "mt-3"),
                children: [
                    /*#__PURE__*/ _jsx(Plus, {
                        className: "size-4 text-grey-11"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "ml-1.5 text-14 font-medium text-grey-11",
                        children: "".concat(createVerb, ' "').concat(value, '"?')
                    })
                ]
            })
        })
    });
});
SelectCreateOption.displayName = "SelectCreateOption";
